import apiFinanzas from './apiBase'

/**
 * Servicio para Cuentas Bancarias
 */
export const cuentasBancariasServicio = {
  /**
   * Listar todas las cuentas bancarias
   */
  async listar() {
    try {
      const response = await apiFinanzas.get('/finanzas/cuentas-bancarias')
      return response.data || response
    } catch (error) {
      console.error('Error al listar cuentas bancarias:', error)
      throw error
    }
  },

  /**
   * Obtener una cuenta bancaria por ID
   */
  async obtener(id) {
    try {
      const response = await apiFinanzas.get(`/finanzas/cuentas-bancarias/${id}`)
      return response.data || response
    } catch (error) {
      console.error('Error al obtener cuenta bancaria:', error)
      throw error
    }
  },

  /**
   * Crear nueva cuenta bancaria
   */
  async crear(datos) {
    try {
      const response = await apiFinanzas.post('/finanzas/cuentas-bancarias', datos)
      return response.data || response
    } catch (error) {
      console.error('Error al crear cuenta bancaria:', error)
      throw error
    }
  },

  /**
   * Actualizar cuenta bancaria
   */
  async actualizar(id, datos) {
    try {
      const response = await apiFinanzas.put(`/finanzas/cuentas-bancarias/${id}`, datos)
      return response.data || response
    } catch (error) {
      console.error('Error al actualizar cuenta bancaria:', error)
      throw error
    }
  },

  /**
   * Eliminar cuenta bancaria
   */
  async eliminar(id) {
    try {
      const response = await apiFinanzas.delete(`/finanzas/cuentas-bancarias/${id}`)
      return response.data || response
    } catch (error) {
      console.error('Error al eliminar cuenta bancaria:', error)
      throw error
    }
  },

  /**
   * Obtener saldo actual de una cuenta
   */
  async obtenerSaldo(id) {
    try {
      const response = await apiFinanzas.get(`/finanzas/cuentas-bancarias/${id}/saldo`)
      return response.data || response
    } catch (error) {
      console.error('Error al obtener saldo:', error)
      throw error
    }
  },

  /**
   * Conciliar cuenta bancaria
   */
  async conciliar(id, datos) {
    try {
      const response = await apiFinanzas.post(`/finanzas/cuentas-bancarias/${id}/conciliar`, datos)
      return response.data || response
    } catch (error) {
      console.error('Error al conciliar cuenta:', error)
      throw error
    }
  }
}

export default cuentasBancariasServicio
